// extracted by mini-css-extract-plugin
var _1 = "uWWsiLNWcIFIuXtzdaXG";
var _2 = "bpFBsinrUAZDJAgCuNU7";
var _3 = "ak4BUd1BJmuY2ANV2npS";
var _4 = "o1flTTbO_llJdHIzJBGz";
export { _1 as "fb-notification-collapse-arrow", _2 as "fb-notification-collapse-content", _3 as "fb-notification-collapse-header", _4 as "fb-notification-collapse-label" }
